// extracted by mini-css-extract-plugin
module.exports = {"container":"CommonItem_container__2-GRk","small":"CommonItem_small__3rLZJ"};